// 资质宝-各资质类型材料维护板块
import request from '@/utils/request'

// 获取企业人员库（安管人员信息）
export const queryStaffLibraryList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/companyPageTabAx',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 安许-查询特种人员信息
export const queryStaffTzryList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/companyPageTabZzb',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 安许-资质材料人员信息提交保存
export const saveAnxyMaterialRecord = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/axxury/batchSave',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询安许-已维护的资质材料人员信息
export const queryAnxyMaterialRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/axxury/querPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 删除安许-已维护的资质材料人员信息
export const removeAnxyMaterialRecord = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/axxury/removeById',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 工程监理-查询注册监理工程师
export const queryGcjlPersonPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/companyPageTabZzb',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 工程监理-保存资质诊断材料维护（同时保存和材料自维护信息）
export const saveGcjlMaintenanceInfo = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/gcJlRy/saveRy',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 工程监理-查询已维护的资质诊断材料信息（人员和材料自维护信息）
export const queryGcjlMaterialRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/gcJlRy/getRyAndMaterialDetail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-综合材料查询
export const queryJzyhMaterialRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/companyZhcl',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-综合材料新增修改
export const saveJzyhMaterialRecord = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/saveOrUpdateZhcl',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-自维护注册人员查询
export const queryJzyhSelfRegisterPerson = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/companyPageTabJzy',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-自维护注册人员查询（已维护）
export const queryJzyhSelfRegisterPersonHas = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/companyPageJzyry',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-增加修改与关联人员
export const saveOrUpdateJzyhSelfRegisterPerson = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/saveOrUpdateRy',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-人员删除
export const removeJzyhSelfRegisterPerson = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/deleteByIds',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-装备分页查询
export const queryJzyhEquipment = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/companyPageZb',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-新增修改设备
export const saveOrUpdateJzyhEquipment = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/saveOrUpdateZb',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-批量删除设备
export const removeJzyhEquipment = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/deleteZbByIds',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-工程业绩分页查询
export const queryJzyhProjectPerformance = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/companyPageGcyj',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 建筑业-工程业绩新增修改
export const saveOrUpdateJzyhProjectPerformance = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/saveOrUpdateGcyj',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 建筑业-批量删除工程业绩
export const removeJzyhProjectPerformance = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyZwh/deleteGcyjByIds',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 工程业绩数据分页查询
export const queryGcyjData = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyjsfzrgcyj/pageJsfzrGcyjInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 工程业绩数据保存
export const saveGcyjData = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyjsfzrgcyj/saveOrUpdateJsfzrYj ',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 工程业绩数据删除
export const removeGcyjData = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/jzyjsfzrgcyj/findDelectById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
